import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {}
        },
        es: {
            translation: {}
        }
    },
    nsSeparator: false,
    keySeparator: true,
    fallbackLng: "en"
});

export default i18n;
